import { CustomMedicalType } from "@teamprevent/common/healthSurveillance/models";
import { Payload } from "@neworbit/redux-helpers";

import * as actions from "./actiontypes";

export type CustomMedicalTypeAction =
      ({ type: typeof actions.LOAD_CUSTOM_MEDICAL_TYPES_SUCCESS } & Payload<CustomMedicalType[]>);

export const loadCustomMedicalTypesSuccess = (payload: CustomMedicalType[]) => ({
    payload,
    type: actions.LOAD_CUSTOM_MEDICAL_TYPES_SUCCESS
});
